import cn from 'classnames'
import React from 'react'

//
import { SiteDataContext } from '../../components'
import SectionHeader, { ALIGN, HEADING_TYPE } from '../SectionHeader'
import Image from 'next/image'
import Link from 'next/link'

const IntegrationSection = ({
  title = '',
  description,
  descriptionTokens = {},
  posIntegrations = [],
  channelsIntegrations = [],
  children,
  action
}) => {
  const { isTextRtl } = React.useContext(SiteDataContext)
  const integrationsArray = [...posIntegrations, ...channelsIntegrations].splice(0, 6)
  return (
    <section
      className={cn('l-section--small l-section--black c-integration-section', {
        'c-integration-section--rtl': isTextRtl
      })}
    >
      <div className="l-container:12/12 l-container--default-spacing c-integration-section__inner-wrapper">
        <SectionHeader
          title={title}
          text={description}
          textTokens={descriptionTokens}
          inverted
          headingType={HEADING_TYPE.h3}
          classes="c-integration-section__section-header"
          align={ALIGN.center}
        >
          {children}
        </SectionHeader>
        <div>
          <div className="c-integration-section__wrapper">
            {integrationsArray.length > 0 &&
              integrationsArray.map((integration) => (
                <IntegrationSectionListItem key={integration.id} integration={integration} />
              ))}
          </div>
        </div>
        <div className="c-integration-section__action-wrapper">{action}</div>
      </div>
    </section>
  )
}

export default IntegrationSection

const IntegrationSectionListItem = ({ integration }) => {
  if (!integration.url) {
    return (
      <div className="c-integration-section__integration">
        <Image
          alt={`${integration.title} logo` || `Integration Logo`}
          src={integration.logo}
          fill
          style={{
            objectFit: 'contain'
          }}
          loading="lazy"
        />
      </div>
    )
  }

  return (
    <Link href={integration.url} className="c-integration-section__integration">
      <Image
        alt={`${integration.title} logo` || `Integration Logo`}
        src={integration.logo}
        fill
        style={{
          objectFit: 'contain'
        }}
        loading="lazy"
      />
    </Link>
  )
}
